//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ReviewLocation',
  props: {
    review: {
      type: Object,
      default: () => {}
    },
    lang: {
      type: String,
      default: 'en'
    },
    locationType: {
      type: String,
      default: 'country'
    }
  },
  computed: {
    trans () {
      if (this.review.locations[this.isTypeExists].name) {
        return this.review.locations[this.isTypeExists]
      }
      if (this.review.locations[this.isTypeExists].trans) {
        return this.review.locations[this.isTypeExists].trans.find(t => t.lang === this.lang)
      }
      return { name: '', slug: null }
    },
    isTypeExists () {
      if (this.review.locations[this.locationType].name || this.review.locations[this.locationType].trans) {
        return this.locationType
      }
      if (this.review.locations.country.name || this.review.locations.country.trans) {
        return 'country'
      }
      if (this.review.locations.region.name || this.review.locations.region.trans) {
        return 'region'
      }
      if (this.review.locations.city.name || this.review.locations.city.trans) {
        return 'city'
      }
      return null
    }
  }
}
